function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { Radio, RadioGroup, useRadioState } from 'reakit/Radio';
import { buildClassNames } from '../../../modules/css-helpers';
import { addVariant } from '../../../modules/variant-helpers';
import { createOwnUpComponent } from '../../components';
import { getOptionValue, OwnUpOptionBreak } from '../../properties';
import { OwnUpRadioBreakStyle, OwnUpRadioButtonIndicatorStyle, OwnUpRadioButtonStyle, OwnUpRadioButtonWrapperStyle, OwnUpRadioGroupStyle, OwnUpRadioTextStyle } from './style';
/**
 * Radio component properties.
 */

var StyledRadioGroup = createOwnUpComponent(RadioGroup, OwnUpRadioGroupStyle);
/**
 * Internal components used to compose the radio group.
 */

var StyledRadioButtonWrapper = createOwnUpComponent('label', OwnUpRadioButtonWrapperStyle);
export var OwnUpRadioButtonWrapper = function OwnUpRadioButtonWrapper(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var builtClass = buildClassNames('ou-radio-group__wrapper', className);
  return /*#__PURE__*/React.createElement(StyledRadioButtonWrapper, _extends({
    className: builtClass
  }, props));
};
var StyledRadioButtonIndicator = createOwnUpComponent('div', OwnUpRadioButtonIndicatorStyle);

var OwnUpRadioButtonIndicator = function OwnUpRadioButtonIndicator(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  var builtClass = buildClassNames('ou-radio-group__indicator', className);
  return /*#__PURE__*/React.createElement(StyledRadioButtonIndicator, _extends({
    className: builtClass
  }, props));
};

var StyledRadioButton = createOwnUpComponent(Radio, OwnUpRadioButtonStyle);
export var OwnUpRadioButton = function OwnUpRadioButton(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  var builtClass = buildClassNames('ou-radio-group__button', className);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OwnUpRadioButtonIndicator, props), /*#__PURE__*/React.createElement(StyledRadioButton, _extends({
    className: builtClass
  }, props)));
};
var StyledRadioBreak = createOwnUpComponent('hr', OwnUpRadioBreakStyle);
export var OwnUpRadioBreak = function OwnUpRadioBreak(_ref4) {
  var className = _ref4.className,
      props = _objectWithoutProperties(_ref4, ["className"]);

  var builtClass = buildClassNames('ou-radio-group__break', className);
  return /*#__PURE__*/React.createElement(StyledRadioBreak, _extends({
    className: builtClass
  }, props));
};
var StyledRadioText = createOwnUpComponent('div', OwnUpRadioTextStyle);
export var OwnUpRadioText = function OwnUpRadioText(_ref5) {
  var className = _ref5.className,
      props = _objectWithoutProperties(_ref5, ["className"]);

  var builtClass = buildClassNames('ou-radio-group__text', className);
  return /*#__PURE__*/React.createElement(StyledRadioText, _extends({
    className: builtClass
  }, props));
};
/**
 * Custom wrapper around Reakkit's Radio Value state.
 *
 * Used to unwrap the default value and invoke onChange listeners.
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.

export function useOwnUpRadioState(_ref6) {
  var onChange = _ref6.onChange,
      value = _ref6.value;
  // HACK: Reakit typings enforce number or string, but they can be anything.
  var radioState = useRadioState({
    state: value
  }); // Return a custom implementation of the "setState" function

  return _objectSpread(_objectSpread({}, radioState), {}, {
    setState: function setState(action) {
      var currentValue = value; // Invoke the action to fetch the new value.

      var newValue = typeof action === 'function' ? action(currentValue) : action; // Call the handler with the new value and the current value.

      onChange(newValue, currentValue); // HACK: Reakit typings enforce number or string, but they can be anything.

      radioState.setState(action);
    }
  });
}
export function OwnUpFullRadioButton(_ref7) {
  var index = _ref7.index,
      variant = _ref7.variant,
      className = _ref7.className,
      radioState = _ref7.radioState,
      disabled = _ref7.disabled,
      buttonOption = _ref7.buttonOption,
      value = _ref7.value;
  var buttonProps = {
    variant: addVariant(variant, buttonOption.variant),
    className: buildClassNames(className, buttonOption.className)
  };

  if (value === buttonOption.value) {
    buttonProps.variant = addVariant(buttonProps.variant, 'checked');
  }

  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: "radio-".concat(index)
  }, /*#__PURE__*/React.createElement(OwnUpRadioButtonWrapper, _extends({}, buttonProps, {
    key: "radio-".concat(index),
    disabled: disabled
  }), /*#__PURE__*/React.createElement(OwnUpRadioButton, _extends({}, buttonProps, radioState, {
    disabled: disabled,
    value: buttonOption.value
  })), /*#__PURE__*/React.createElement(OwnUpRadioText, buttonProps, buttonOption.display)));
}
/**
 * A simple collection of options in which a user may select one.
 *    For more complex radio button groups use RadioGroupController and OwnUpFullRadioButton.
 * @param props - see {@link OwnUpRadioButtonProperties}
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.

export function OwnUpRadioGroup(_ref8) {
  var value = _ref8.value,
      options = _ref8.options,
      className = _ref8.className,
      variant = _ref8.variant,
      onChange = _ref8.onChange,
      disabled = _ref8.disabled,
      groupName = _ref8.groupName,
      props = _objectWithoutProperties(_ref8, ["value", "options", "className", "variant", "onChange", "disabled", "groupName"]);

  var actualValue = useMemo(function () {
    return getOptionValue(value).value;
  }, [value]);
  var radioState = useOwnUpRadioState({
    value: actualValue,
    onChange: onChange
  });
  var radioButtons = useMemo(function () {
    return options.map(function (option, index) {
      if (option === OwnUpOptionBreak) {
        return /*#__PURE__*/React.createElement(OwnUpRadioBreak, {
          className: className,
          variant: variant
        });
      }

      var displayExpansion = false;
      var val = getOptionValue(option);
      var optionExpansion = _typeof(option) === 'object' && 'optionExpansion' in option ? option.optionExpansion : undefined;
      var buttonProps = {
        variant: addVariant(variant, val.variant),
        className: buildClassNames(className, val.className)
      };

      if (actualValue === val.value) {
        buttonProps.variant = addVariant(buttonProps.variant, 'checked');
        displayExpansion = true;
      }

      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "radio-".concat(index)
      }, /*#__PURE__*/React.createElement(OwnUpRadioButtonWrapper, _extends({}, buttonProps, {
        key: "radio-".concat(index),
        disabled: disabled
      }), /*#__PURE__*/React.createElement(OwnUpRadioButton, _extends({}, buttonProps, radioState, {
        disabled: disabled,
        value: val.value
      })), /*#__PURE__*/React.createElement(OwnUpRadioText, buttonProps, val.display)), displayExpansion && optionExpansion ? optionExpansion : null);
    });
  }, [actualValue, className, disabled, radioState, options, variant]);
  var builtClass = buildClassNames('ou-radio-group', className);
  return /*#__PURE__*/React.createElement(StyledRadioGroup, _extends({
    className: builtClass,
    "aria-label": groupName
  }, radioState, {
    disabled: disabled
  }, props), radioButtons);
}